import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import store from './store'

Vue.use(VueRouter)
Vue.use(Vuex)

const Contacts = () => import(/* webpackChunkName: "other" */'@/views/Contacts.vue')
const Services = () => import(/* webpackChunkName: "other" */'@/views/Services.vue')
const Decisions = () => import(/* webpackChunkName: "other" */'@/views/Decisions.vue')
const Support = () => import(/* webpackChunkName: "other" */'@/views/Support.vue')

const UkDispatch = () => import(/* webpackChunkName: "dispatch" */'@/views/uk-dispatch/UkDispatch.vue')
const SntDispatch = () => import(/* webpackChunkName: "dispatch" */'@/views/snt-dispatch/SntDispatch.vue')

const Products = () => import(/* webpackChunkName: "product" */'@/views/Products.vue')
const Software = () => import(/* webpackChunkName: "product" */'@/views/software/Software.vue')
const Category = () => import(/* webpackChunkName: "product" */'@/views/Category.vue')
const Product = () => import(/* webpackChunkName: "product" */'@/views/product/Product.vue')

const Pnd = () => import(/* webpackChunkName: "static" */'@/views/static/pnd.vue')
const Reglament = () => import(/* webpackChunkName: "static" */'@/views/static/reglament.vue')
// const Tariffs = () => import(/* webpackChunkName: "static" */'@/views/static/tariffs.vue')

const Cases = () => import(/* webpackChunkName: "case" */'@/views/Cases.vue')
const Case = () => import(/* webpackChunkName: "case" */'@/views/case/Case.vue')

const Main = () => import(/* webpackChunkName: "index" */'@/views/main/Main.vue')

const routes = [
    {path: '/', component: Main},
    {path: '/products/', redirect: '/products/water'},
    {path: '/products/:category/:id', component: Product},
    {path: '/products/:category', component: Category},
    {path: '/decisions', component: Decisions},
    {path: '/decisions/dispatching-snt', component: SntDispatch},
    {path: '/decisions/uk-dispatch', component: UkDispatch},
    {path: '/decisions/software', component: Software},
    {path: '/services', component: Services},
    {path: '/cases', component: Cases},
    {path: '/cases/:id', component: Case},
    {path: '/support', component: Support},
    {path: '/contacts', component: Contacts},
    {path: '/pnd', component: Pnd},
    {path: '/reglament', component: Reglament},
    // {path: '/tariffs', component: Tariffs},
    {path: '*', component: Main},
]

const router = new VueRouter({
    routes
});

new Vue({
    el: '#app',
    store,
    render: h => h(App),
    router: router,
    mutations: {
        setRouteActive: (state) => {
            console.log(state)
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js